import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Lock, Mail } from 'lucide-react';
export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) {
      setError('Please enter email and password');
      return;
    }
    setIsLoading(true);
    setError('');
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      // Mock successful login for demo purposes
      navigate('/dashboard');
    }, 1000);
  };
  return <div className="min-h-screen bg-[#376770] flex flex-col items-center justify-center px-4 py-12" data-id="element-702">
      {/* Logo */}
      <div className="mb-8 text-center" data-id="element-703">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jJkprGARCzfGvbLTaJLb3b/Elze_logo.svg" alt="Elze Logo" className="h-16 w-auto mx-auto filter brightness-0 invert-[1]" data-id="element-704" />
      </div>
      {/* Form Container */}
      <div className="w-full max-w-md bg-white rounded-lg shadow-xl overflow-hidden" data-id="element-705">
        <div className="px-6 py-8" data-id="element-706">
          <h2 className="text-2xl font-semibold text-[#164149] mb-6 text-center" data-id="element-707">
            Log in to your account
          </h2>
          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded" data-id="element-708">
              {error}
            </div>}
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-709">
            <div data-id="element-710">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-711">
                Email
              </label>
              <div className="relative" data-id="element-712">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-713">
                  <Mail size={18} className="text-gray-400" data-id="element-714" />
                </div>
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none text-sm" placeholder="name@example.com" required data-id="element-715" />
              </div>
            </div>
            <div data-id="element-716">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-717">
                Password
              </label>
              <div className="relative" data-id="element-718">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-719">
                  <Lock size={18} className="text-gray-400" data-id="element-720" />
                </div>
                <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="block w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-md shadow-sm focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none text-sm" placeholder="••••••••" required data-id="element-721" />
                <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-722">
                  {showPassword ? <EyeOff size={18} className="text-gray-400 hover:text-gray-600" data-id="element-723" /> : <Eye size={18} className="text-gray-400 hover:text-gray-600" data-id="element-724" />}
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-725">
              <div className="flex items-center" data-id="element-726">
                <input id="remember-me" name="remember-me" type="checkbox" checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} className="h-4 w-4 text-[#376770] focus:ring-[#376770]/20 border-gray-300 rounded" data-id="element-727" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700" data-id="element-728">
                  Remember me
                </label>
              </div>
              <div className="text-sm" data-id="element-729">
                <Link to="/forgot-password" className="font-medium text-[#376770] hover:text-[#164149]" data-id="element-730">
                  Forgot password?
                </Link>
              </div>
            </div>
            <div data-id="element-731">
              <button type="submit" disabled={isLoading} className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#376770] hover:bg-[#164149] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#376770] transition-colors" data-id="element-732">
                {isLoading ? <span className="flex items-center" data-id="element-733">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-734">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-735"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-736"></path>
                    </svg>
                    Logging in...
                  </span> : 'Log in'}
              </button>
            </div>
          </form>
          <div className="mt-6 text-center" data-id="element-737">
            <p className="text-sm text-gray-600" data-id="element-738">
              Don't have an account?{' '}
              <Link to="/signup" className="font-medium text-[#376770] hover:text-[#164149]" data-id="element-739">
                Sign up
              </Link>
            </p>
          </div>
        </div>
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 text-center" data-id="element-740">
          <p className="text-xs text-gray-500" data-id="element-741">
            By logging in, you agree to our{' '}
            <Link to="/terms" className="text-[#376770] hover:underline" data-id="element-742">
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link to="/privacy" className="text-[#376770] hover:underline" data-id="element-743">
              Privacy Policy
            </Link>
          </p>
        </div>
      </div>
    </div>;
}